<template>
  <div class="hello">
    <h1>ModuleNotFound Loaded!</h1>
  </div>
</template>

<script>
export default {
  name: 'ModuleNotFound',
  // data() {
  //   return {
  //     'msg': 'RObert'
  //   }
  // },
  mounted() {
    console.log('SelectStone mounted');
  },
}
</script>

<style scoped>
</style>
